import PropTypes from 'prop-types';
import { BlockRenderer } from '@shared/components/BlockKit';
import SafeHtmlRenderer from '@shared/components/Common/SafeHtmlRenderer';

const StepInstructions = ({ 
  instructions,
  replacements = {}
}) => {
  // check to see if instructions is an array or string
  if(Array.isArray(instructions)) {
    
    return (
      <BlockRenderer blocks={instructions} replacements={replacements} />
    );
  }else if(typeof instructions === 'string' && instructions.length > 0) {
    return (
      <SafeHtmlRenderer
        html={instructions}
        className="step-instructions"
        replacements={replacements}
      />
    );
  }else{
    return null;
  }  
};

StepInstructions.propTypes = {
  instructions: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  replacements: PropTypes.object,
};

StepInstructions.defaultProps = {
  instructions: "",
  replacements: {},
};

export default StepInstructions;
